





























































































































































import Vue from 'vue';
import moment from 'moment';
import { numeric, required, sameAs, maxLength } from 'vuelidate/lib/validators';
import {
  lengthRange,
  password,
  username,
} from '@/validations';
import {
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { api, MEMBER_API_SUB_URLS } from '@/api';
import {
  FormValidation,
  CloseStepperWrapper,
  LoadingMessage,
} from '@/mixins';
import { ExtendMixins } from '@/services';
import { RegistrationCredentialsFormModel, StepperSteps } from '@/@types/member';
import PasswordValidationIcon from './password-status.component.vue';

interface Data {
  isPasswordVisible: boolean;
  currentStep: StepperSteps;
}

export default ExtendMixins(
  FormValidation,
  CloseStepperWrapper,
).extend({
  name: 'RegisterStep3Credentials',
  props: {
    formModel: {
      type: Object as () => RegistrationCredentialsFormModel,
      required: true,
    },
    step: {
      type: Object as () => StepperSteps,
      required: true,
    },
    error: String,
    brand: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      isPasswordVisible: false,
      currentStep: this.step,
    };
  },
  validations: {
    formModel: {
      username: {
        required,
        lengthRange: lengthRange(6, 14),
        usernameValidChars: username.validChars,
      },
      password: {
        lengthRange: lengthRange(15, 256),
        pwFirstChar: password.firstChar,
        pwValidChars: password.validChars,
        pwRepeatingChars: password.repeatingChars,
        pwAlphaNumericChars: password.alphaNumeric,
        pwSpecialChar: password.specialChar,
        pwUpperLower: password.upperLower,
        required,
      },
      terms: {
        required,
      },
    },
  },
  computed: {
    termsLabel(): string {
      return this.$options.filters.varReplace(
          this.$options.filters.t('register-step-3-credentials-terms-label'),
          {
            termsOfUseLink: this.termsOfUseLink,
            privacyPolicyLink: this.privacyPolicyLink,
          },
        );
    },
    termsErrors(): string[] {
      const formField = 'formModel.terms';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'register_form-error_terms-and-conditions_required',
            'global_form-error_terms-and-conditions_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
    termsOfUseLink(): string {
      return `${this.getPublicSiteRoot}${this.$options.filters.t('footer-public-link-legal-terms')}`;
    },
    privacyPolicyLink(): string {
      return `${this.getPublicSiteRoot}${this.$options.filters.t('footer-public-link-privacy')}`;
    },
    getPublicSiteRoot(): string {
      if (process.env.VUE_APP_HOMEPAGE_URL) {
        return process.env.VUE_APP_HOMEPAGE_URL;
      }
      return this.$options.filters.t('login_home-url') + '/';
    },
    brandPhone(): string {
      return this.$options.filters.t(`register-page-help-phone-${this.brand}`) ;
    },
  },
  components: {
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
    PasswordValidationIcon,
  },
  methods: {
    submit(): void {
      this.$emit('submitRegistrationCredentials');
    },
    refreshAction(): void {
      this.step.isError = false;
    },
    doneAction(): void {
      this.$router.push('login');
    },
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
});
